// Module
var code = "<div id=\"V-B64665D0-36B5-467C-8DEF-54580A06EB49\"> <button class=\"V-B64665D0-36B5-467C-8DEF-54580A06EB49\"> {Binding content} </button> </div>";
// Exports
export default code;